import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

function Navigation({ onSearch }) {
  const location = useLocation();
  const [query, setQuery] = useState('');
  const [queryTooShort, setQueryTooShort] = useState(false);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (value.length >= 3) {
      setQueryTooShort(false);
    }
  };

  const triggerSearch = () => {
    if (query.length < 3) {
      setQueryTooShort(true);
      return;
    }

    const context =
      location.pathname === '/testplans'
        ? 'plans'
        : location.pathname === '/testcatalog'
          ? 'catalog'
          : 'default';

    if (onSearch) {
      onSearch(query, context);
    }
  };

  const handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      triggerSearch();
    }
  };

  return (
    <nav
      className="navbar navbar-light bg-white fixed-top shadow-sm p-3 d-flex justify-content-between align-items-center"
      style={{ height: '70px' }}
    >
      <NavLink
        to="/"
        end
        style={{ marginLeft: '16.6667%' }}
        className={({ isActive }) => `navbar-brand${isActive ? ' active' : ''}`}
      >
        Home
      </NavLink>
      <NavLink
        to="/testcatalog"
        end
        className={({ isActive }) => `navbar-brand${isActive ? ' active' : ''}`}
      >
        Test Catalog
      </NavLink>
      <NavLink
        to="/testplans"
        end
        className={({ isActive }) => `navbar-brand${isActive ? ' active' : ''}`}
      >
        Test Plans
      </NavLink>
      <NavLink
        to="/analytics"
        end
        className={({ isActive }) => `navbar-brand${isActive ? ' active' : ''}`}
      >
        Analytics
      </NavLink>

      <div className="d-flex align-items-start ms-auto">
        <input
          className="form-control"
          style={{ width: '300px', height: '38px' }}
          type="text"
          value={query}
          onChange={handleInputChange}
          onKeyDown={handleEnterPress}
          placeholder="Search (mongo scoring match)..."
        />
        <button className="btn btn-success ms-2" onClick={triggerSearch}>
          Search
        </button>
      </div>

      {queryTooShort && (
        <div
          className="position-absolute text-danger"
          style={{ top: '70px', right: '16.6667%', fontSize: '0.9rem' }}
        >
          Please enter at least 3 characters.
        </div>
      )}
    </nav>
  );
}

export default Navigation;
